<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { defineEmits } from "vue";

const { t } = useI18n();

const emit = defineEmits<{
  (e: "clicked"): void;
}>();
</script>

<template>
  <button class="flex h-14 items-center group" @click="emit('clicked')">
    <span class="mr-2 btn-text">{{ t("buttons.close") }}</span>
    <span
      class="flex items-center justify-center size-[42px] xl:size-14 rounded-full icon"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1 1L15 15M15 1L1 15"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </span>
  </button>
</template>

<style scoped>
.btn-text {
  @apply sf-pro font-normal text-sm leading-[21px] xl:font-medium xl:text-base xl:leading-100p text-brown
       group-hover:text-active
       group-active:text-active-dark;
}

.icon {
  @apply text-brown bg-ternary
           group-hover:border group-hover:border-active group-hover:text-active group-hover:bg-hover
         group-active:bg-active group-active:text-white;
}
</style>
